<template>
  <div :class="$style['pt-production-task-form']" v-if="value">
    <pt-sub-title title="任务单信息"></pt-sub-title>
    <pt-form-item label="任务单编号：" :labelWidth="labelWidth">
      <span>{{bill.billCode}}</span>
    </pt-form-item>
    <pt-form-item label="开始日期：" :labelWidth="labelWidth" >
      <el-date-picker v-model="form.startTime" type="date" placeholder="选择日期" ></el-date-picker>
    </pt-form-item>
    <pt-form-item label="目标日期：" :labelWidth="labelWidth" :required="true">
      <el-date-picker  v-model="form.endTime" type="date" placeholder="选择日期" data-vv-as="目标日期" v-validate="'required'"></el-date-picker>
    </pt-form-item>
    <pt-form-item label="实验人员：" :labelWidth="labelWidth" :required="true">
      <lab-staff-selector v-model="form.labTester.organizationUserId" @getObj="getObj" data-vv-as="实验人员" v-validate="'required'"></lab-staff-selector >
    </pt-form-item>
    <pt-form-item label="备注：" :labelWidth="labelWidth" >
      <el-input v-model="form.comment" placeholder="请填写备注" type="textarea"></el-input>
    </pt-form-item>
    <pt-sub-title title="所属委托单信息"></pt-sub-title>
    <pt-form-item label="委托单编号：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
      <span>{{bill ? bill.billCode :'--'}}</span>
    </pt-form-item>
    <pt-form-item label="是否偏离：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
      <span>
        {{bill ? bill.deviate_text : '--'}}
          {{bill ? bill.deviateInfo : ''}}
        </span>
    </pt-form-item>
    <pt-form-item label="是否加急：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
      <span>
        <template v-if="!bill">
            --
          </template>
          <template v-else>
            <el-tag type="danger" size="small" v-if="bill.urgent">加急</el-tag>
            <template v-else>否</template>
          </template>
      </span>
    </pt-form-item>
    <pt-form-item label="预计交付日期：" :labelWidth="labelWidth" :lineHeight="lineHeight" :labelColor="labelColor">
      <span>{{bill ? bill.delivery_date :'--'}}</span>
    </pt-form-item>
    <pt-sub-title title="样品列表"></pt-sub-title>
    <lab-order-in-task :order="form" :bill="bill"></lab-order-in-task>

  </div>
</template>

<script>
import { validate } from 'utils/validate'
import labOrderInTask from '../lab-order-in-task.vue'
import labStaffSelector from 'cps/selector/lab-staff-selector.vue'
import formMixins from 'mixins/form'
// 组件class前缀
const prefixCls = 'pt-production-task-form'

export default {
  name: 'pt-production-task-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
  },
  components:{
    labStaffSelector,
    labOrderInTask
  },
  props: {
    value: {
      type: Object,
      default: () => { }
    },
    bill: {
      type: Object,
      default: () => { }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      labelWidth: '170px',
      lineHeight:'30px',
      labelColor:"#409eff",
      form: this.value?.id ? this.value : {
        
      },
      selectOrder:[],
      removeLoading:false,
      distributeLoading:false,
      showDialog:false,
      addLoading:false,
      currentTester:{},
    }
  },
  watch: {
    form (val) {
      this.$emit('input', JSON.parse(JSON.stringify(val)))
    },
    value (val) {
      this.form = val
    },
  },
  methods: {
    getObj(val){
      const {label,value} = val
      this.form.labTester = {
        name:label,
        organizationUserId:value
      }
    },
    formValidata () {
      return validate(this, this.form)
    },
    cancel () {
      history.go(-1)
    },
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-production-task-form{
  :global{
    .el-select{
      width: 2.2rem;
    }
    .el-textarea{
      width: 3.2rem;
    }
  }
}
</style>
